class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    /* mcp megamenu */
    this.shopMenu = this.querySelector('.js-shop-menu');
    if (!this.shopMenu) return;
    this.shopMenuChildren = this.querySelectorAll('.js-child');
    console.log('shopMenuChildren', this.shopMenuChildren);
    //this.shopMenu.addEventListener('mouseover', this.onShopMenuHover.bind(this));
  }

  onShopMenuHover(event) {
    console.log('LOL', event.target.dataset.handle);
    this.hideShopMenuChildren();
    if (!this.querySelector(`#${event.target.dataset.handle}`)) return;
    this.querySelector(`#${event.target.dataset.handle}`).classList.remove('hidden');
  }

  hideShopMenuChildren() {
    this.shopMenuChildren.forEach((menu) => {
      menu.classList.add('hidden');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Close all details when open one
const details = document.querySelectorAll('.accordion details');
if (details) {
  details.forEach((targetDetail) => {
    targetDetail.addEventListener('click', () => {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute('open');
        }
      });
    });
  });
}
